<template>
  <standard-dialog
    v-model="model"
    :title="restaurant ? toLatin(restaurant.name) : $t('restaurant')"
    :subtitle="restaurant ? `ID: ${restaurant.id}` : ''"
    icon="mdi-store"
    max-width="700"
    hide-actions
  >
    <div v-if="restaurant" class="restaurant-details">
      <!-- Basic Info Card -->
      <v-card outlined class="mb-4">
        <v-card-text class="pa-4">
          <!-- Contact Information -->
          <div class="info-section">
            <div class="info-row d-flex align-center mb-2">
              <v-icon small color="orange" class="mr-3">mdi-map-marker</v-icon>
              <div>
                <div class="text-caption grey--text">{{ $t("address") }}</div>
                <div class="text-body-2">{{ toLatin(restaurant.address) }}</div>
              </div>
            </div>

            <div class="info-row d-flex align-center mb-2">
              <v-icon small color="orange" class="mr-3">mdi-city</v-icon>
              <div>
                <div class="text-caption grey--text">{{ $t("city") }}</div>
                <div class="text-body-2">
                  {{ restaurant.city ? toLatin(restaurant.city.name) : "-" }}
                </div>
              </div>
            </div>

            <div class="info-row d-flex align-center mb-2">
              <v-icon small color="orange" class="mr-3">mdi-phone</v-icon>
              <div>
                <div class="text-caption grey--text">{{ $t("phone") }}</div>
                <div class="text-body-2">{{ restaurant.phone || "-" }}</div>
              </div>
            </div>

            <div class="info-row d-flex align-center mb-2">
              <v-icon small color="orange" class="mr-3">mdi-email</v-icon>
              <div>
                <div class="text-caption grey--text">{{ $t("email") }}</div>
                <div class="text-body-2">{{ restaurant.email || "-" }}</div>
              </div>
            </div>
          </div>
        </v-card-text>
      </v-card>

      <!-- Map - samo ako restoran ima unešene koordinate -->
      <v-card v-if="hasCoordinates" outlined>
        <l-map style="height: 220px" :zoom="15" :center="mapCenter">
          <l-tile-layer :url="tileUrl" :attribution="tileAttribution" />
          <l-marker :lat-lng="mapCenter" />
        </l-map>
      </v-card>
    </div>
  </standard-dialog>
</template>

<script>
import hasModel from "@/mixins/hasModel";
import StandardDialog from "@/components/dialogs/StandardDialog.vue";
import { Icon } from "leaflet";
import { LMap, LTileLayer, LMarker } from "vue2-leaflet";

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

export default {
  name: "RestaurantDetailsDialog",
  mixins: [hasModel],
  props: {
    restaurant: {
      type: Object,
      default: null,
    },
  },
  components: {
    StandardDialog,
    LMap,
    LTileLayer,
    LMarker,
  },
  data() {
    return {
      loading: false,
      tileUrl: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      tileAttribution: "",
    };
  },
  computed: {
    hasCoordinates() {
      return !!(this.restaurant?.latitude && this.restaurant?.longitude);
    },
    mapCenter() {
      return [Number(this.restaurant.latitude), Number(this.restaurant.longitude)];
    },
  },
  methods: {
    getUserTypeColor(type) {
      const colors = {
        admin: "orange",
        restaurant: "blue",
        report_guest: "green",
        delivery: "purple",
      };
      return colors[type] || "grey";
    },
  },
};
</script>

<style scoped>
.restaurant-details {
  max-height: 70vh;
}

.info-section {
  padding-left: 4px;
}

.info-row {
  min-height: 48px;
}

.border-bottom {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}

.user-item:last-child {
  padding-bottom: 0;
}

.delivery-info {
  padding: 0 8px;
}
</style>
